import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "angelsquad.member";

export const api = axios.create({
    baseURL: `${BACKEND_URL}/api`,
    withCredentials: true,           // for admin JWT cookie
    headers: { "Content-Type": "application/json" },
});

// Attach X-Member-Id from localStorage on every request (for member endpoints).
api.interceptors.request.use((config) => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed?.memberId) {
                config.headers["X-Member-Id"] = parsed.memberId;
            }
        }
    } catch { /* ignore */ }
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    }
    // Structured backend errors (e.g. cooldown) carry a friendly `message`.
    if (detail && typeof detail.message === "string") return detail.message;
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
